import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import LoadingPage from '@/common/pages/LoadingPage';
import ComplimentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/complimentImagesIcon.svg?react';
import DocumentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/documentImagesIcon.svg?react';
import VehicleImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/vehicleImagesIcon.svg?react';
import {
  INITIAL_ADJUSTER_IMAGES_LINKS,
  INITIAL_VISIT_ADJUSTER_IMAGES_LINKS,
} from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import { GetInitialVisitAdjusterEntryTabsQueryResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialvisitAdjusterEntryTabs/getInitialvisitAdjusterEntryTabsQuery.type';
import { getInitialVisitAdjusterEntryTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialvisitAdjusterEntryTabs/getInitialvisitAdjusterEntryTabsQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import OfflineShowPhotoInformationModal from '@/modules/OfflineFiles/components/modals/OfflineShowPhotoInformationModal';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { getHasOfflineShootingQueryOptions } from '@/modules/OfflineFiles/queries/getHasOfflineShooting/getHasOfflineShootingQueryOptions';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
export default () => {
  return (
    <MainLayout title="کارشناسی / تصاویر" header="titleHeader">
      <AdjusterImageEntryTabs />
    </MainLayout>
  );
};

type TabNames = 'vehicle_image' | 'document_image' | 'additional_image';

const AdjusterImageEntryTabs = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { resetDamagedPoints } = useDamagedPoints();
  const { resetCameraStore } = useImageFlowStore();
  const { getCurrentFileOfflineImages } = useGetOfflineImages();
  const { closeModal, open, openModal } = useModal();

  const { data: offlineShootingData } = useQuery(
    getHasOfflineShootingQueryOptions({
      id: id!,
      userType: 'initial',
    }),
  );
  const { data } = useQuery(
    getInitialVisitAdjusterEntryTabsQueryOptions({
      id: +id!,
    }),
  );
  const { data: serverInitialVisitImages, isPending } = useQuery(
    getDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: !!data?.find((item) => item.name === 'vehicle_image')
        ?.is_card_active,
      participantRoleType: 'initial',
    }),
  );

  const renderRoute = async (
    item: GetInitialVisitAdjusterEntryTabsQueryResponseType,
  ) => {
    const editable = item.editable;
    let hasOffline = false;
    if (
      item.name === 'vehicle_image' &&
      offlineShootingData?.has_offline_shooting
    ) {
      hasOffline = (await getCurrentFileOfflineImages({})).hasOffline;
      if (!serverInitialVisitImages?.vehicle.length && !hasOffline) {
        return openModal();
      }
    }

    let tabIcon = {
      vehicle_image: editable
        ? !serverInitialVisitImages?.vehicle.length && !hasOffline
          ? INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_VEHICLE_IMAGES.edit(id!)
          : INITIAL_VISIT_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_SERVER_IMAGE_PREVIEW(
              id!,
            )
        : INITIAL_VISIT_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_SERVER_IMAGE_PREVIEW_SHOW(
            id!,
          ),

      document_image: item.editable
        ? INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_DOCUMENT.edit(id!)
        : INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_DOCUMENT.show(id!),
      additional_image: item.editable
        ? INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_ADDITIONAL_IMAGES.edit(
            id!,
          )
        : INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_ADDITIONAL_IMAGES.show(
            id!,
          ),
    };
    return tabIcon[item.name];
  };

  const goToFile = async (
    item: GetInitialVisitAdjusterEntryTabsQueryResponseType,
  ) => {
    const path = await renderRoute(item);
    if (path) {
      navigate(path);
    }
  };

  useEffect(() => {
    resetDamagedPoints();
    resetCameraStore();
  }, []);

  return (
    <>
      <Box pt="2rem">
        {isPending ? (
          <LoadingPage />
        ) : (
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              position: 'relative',
              top: '-5px',
            })}
          >
            <Box
              className={css({
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              })}
            >
              <Box>
                {data?.map(
                  (item) =>
                    item.is_card_active && (
                      <CardButton
                        key={item.name}
                        cardProps={{
                          className: css({ marginY: '1rem' }),
                          cursor: item.is_card_active
                            ? 'pointer'
                            : 'not-allowed',
                          onClick: () => item.is_card_active && goToFile(item),
                        }}
                        hasArrow
                        title={item.fa_name}
                        renderIcon={() =>
                          renderIcon(item.name as unknown as TabNames)
                        }
                      />
                    ),
                )}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <OfflineShowPhotoInformationModal
        confirmButtonText="شروع فرایند عکس برداری"
        open={open}
        closeModal={() => {
          closeModal();
          navigate(
            INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_VEHICLE_IMAGES.edit(
              id!,
            ),
          );
        }}
      />
    </>
  );
};
const renderIcon = (tabName: TabNames) => {
  let tabIcon: Record<TabNames, React.JSX.Element> = {
    additional_image: <ComplimentImagesIcon />,
    document_image: <DocumentImagesIcon />,
    vehicle_image: <VehicleImagesIcon />,
  };
  return tabIcon[tabName];
};
